@use './list-vars';
@use './list-common';

:host {
  @include list-vars.wb-list-vars;
  @include list-common.wb-list;
}

:host(:not([continue-counter])) {
  @include list-common.wb-list-reset-counter;
}
